// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Iyrjh","toggleWrap":"styles_toggleWrap__2yqIx","content":"styles_content__2sLeC","selectAreaCode":"styles_selectAreaCode__dUA2k"};